import { render, staticRenderFns } from "./Capability.vue?vue&type=template&id=f32b59ea&scoped=true&"
import script from "./Capability.vue?vue&type=script&lang=js&"
export * from "./Capability.vue?vue&type=script&lang=js&"
import style0 from "./Capability.vue?vue&type=style&index=0&id=f32b59ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32b59ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
